import type { Watcher } from '@/types';

import { request } from './client';

export interface WatcherPayload {
  preferences?: {
    symbols?: string[];
    sentiments?: string[];
    sources?: string[];
  };
  prompt?: string | null;
  active?: boolean;
  data_source?: 'financial_news' | 'financial_reports';
}

export interface WatchersResponse {
  watchers: Watcher[];
}

export interface CreateWatcherResponse {
  success: boolean;
  message: string;
  watcher: Watcher;
}

export interface UpdateWatcherResponse {
  success: boolean;
  message: string;
  watcher: Watcher;
}

export interface DeleteWatcherResponse {
  success: boolean;
  message: string;
}

/**
 * Fetch all watchers for the authenticated user
 */
export async function getWatchers(): Promise<Watcher[]> {
  const response = await request<WatchersResponse>({
    path: '/api/watchers',
  });
  return response.watchers;
}

/**
 * Create a new watcher
 */
export async function createWatcher(payload: WatcherPayload): Promise<Watcher> {
  const response = await request<CreateWatcherResponse, WatcherPayload>({
    path: '/api/watcher',
    method: 'POST',
    body: payload,
  });
  return response.watcher;
}

/**
 * Update an existing watcher
 */
export async function updateWatcher(
  watcherId: string,
  payload: WatcherPayload
): Promise<Watcher> {
  const response = await request<UpdateWatcherResponse, WatcherPayload>({
    path: `/api/watcher/${watcherId}`,
    method: 'PATCH',
    body: payload,
  });
  return response.watcher;
}

/**
 * Delete a watcher
 */
export async function deleteWatcher(watcherId: string): Promise<void> {
  await request<DeleteWatcherResponse>({
    path: `/api/watcher/${watcherId}`,
    method: 'DELETE',
  });
}
